import { createContext } from 'react';

// holds the org that we're currently viewing
const OrganizationContext = createContext({});

export default OrganizationContext;
